module.exports = __webpack_public_path__ + "static/media/secondary_weapon_attack.edaef90a.png";